import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/games')({ component: AdminGamesLayout });

/**
 * The games section, which is three screens rather than one: the list, a game's editor, and a
 * game's builds.
 *
 * It holds nothing of its own. The list lives in `admin.games.index.tsx` — it used to be here,
 * which meant this route rendered the list instead of its children and the build screen could
 * not be reached at all. `/admin` already gates the whole section on the admin role, and each
 * screen below restates it.
 */
function AdminGamesLayout() {
  return <Outlet />;
}
